export function getUserTestGroup(testUUID: string, groups: string[], distribution: number = 0.5): string {
  const urlParams = new URLSearchParams(window.location.search);
  const groupParam = urlParams.get('swTestGroup');
  if (groupParam) {
    localStorage.setItem(testUUID, groupParam);
    return groupParam;
  }
  const existGroup = localStorage.getItem(testUUID);
  if (existGroup) {
    return existGroup;
  }

  const rand = Math.random();
  const group = rand < distribution ? groups[0] : groups[1];
  localStorage.setItem(testUUID, group);
  return group;
}
